import React from 'react';
import styled from 'styled-components';
import { AnalyticsPromos } from '../utils/analytics';
import { PromoWideType } from '../types/entities';
import { PictureWithSources } from './common/PictureWithSources';

const Picture = styled(PictureWithSources)`
    display: block;
    aspect-ratio: 125 / 22;
`;

type Props = {
    promo: PromoWideType
};

type State = {
    analytics_setup: boolean
};

class PromoWide extends React.PureComponent<Props, State> {
    private ref:React.RefObject<HTMLAnchorElement> = React.createRef();

    constructor(props:Props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.state = { analytics_setup: false };
    }

    componentDidMount() {
        this.setup();
    }
    
    componentDidUpdate() {
        this.setup();
    }

    setup() {
        if (!this.ref.current || this.state.analytics_setup) return;

        this.setState({ analytics_setup: true });
        const { promo } = this.props;
        
        setTimeout(() => {
            AnalyticsPromos.observe('promo_wide', promo.id, promo.name, this.ref.current);
        }, 1500);
    }

    onClick(event:React.MouseEvent<HTMLElement>) {
        const { promo } = this.props;
        const openInNewWindow:boolean = promo.target !== '_self' || event.altKey || event.ctrlKey || event.shiftKey;

        AnalyticsPromos.trackClick('promo_wide', promo.id, promo.name, openInNewWindow ? null : () => {
            document.location = promo.url;
        });

        if (!openInNewWindow) event.preventDefault();
    }

    render() {
        const { promo } = this.props;

        if (!promo) {
            return null;
        }

        return <a href={promo.url || '#'} target={promo.target} ref={this.ref} onClick={this.onClick} className='o-ad-w-100'>
            <Picture
                images={promo.images ? promo.images.image : undefined}
                fallback={promo.image_url}
                title={promo.name}
                lazy
            />
        </a>;
    }
}

export default PromoWide;